module.exports = __webpack_public_path__ + "img/share-coupon1.3b2b956d.png";